import { z } from "zod";
import { ENTITY_NAMES } from "@miplatform/constants";

export const configWorkOrderTemplateSchema = z.object({
  name: z
    .string()
    .min(1, `${ENTITY_NAMES.WORK_ORDER_TEMPLATE} Name is required`),
  shortName: z
    .string()
    .min(1, "Short Name is required")
    .max(8, "Short Name must be at most 8 characters"),
  abbreviation: z
    .string()
    .min(1, "Abbreviation is required")
    .max(3, "Abbreviation must be at most 3 characters"),
  description: z.string().optional().nullable(),
  color: z.string().min(1, "Color is required"),
  noStepsRequired: z.boolean().optional().nullable(), // TODO: this will be addressed in follow-up story
  orderTemplateId: z
    .string()
    .uuid(`${ENTITY_NAMES.ORDER_TEMPLATE} is required`),
  tradeId: z.string().uuid(),
  workType: z.enum(["Office", "Field"]),
  module: z.string().min(1),
  steps: z
    .array(
      z.object({
        id: z.string(),
        title: z.string(),
        priorityOrder: z.number(),
        modifiedOn: z.string(),
      })
    )
    .optional(),
  calendarSetId: z
    .union([z.string().uuid(), z.literal(""), z.null()])
    .optional(),
  calendarCuttoffTime: z.any().optional().nullable(),
  autoAssign: z.boolean().optional(),
  resourceAssignments: z
    .array(
      z.object({
        resourceId: z.string().uuid(),
        autoAssignmentRatio: z.number().min(0),
        performanceMultiplier: z.number().int().min(0).max(100),
        displayOrder: z.number().int().min(1),
      })
    )
    .optional(),
  allDayAssignment: z.boolean().optional(),
  autoAssignmentWindows: z
    .array(
      z.object({
        start: z.any().optional().nullable(),
        end: z.any().optional().nullable(),
      })
    )
    .optional(),
});
